/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AppliedContractTermsResource } from './';
import {
    AppliedContractTermsResourceFromJSON,
    AppliedContractTermsResourceFromJSONTyped,
    AppliedContractTermsResourceToJSON,
} from './';
import type { ContractInvoicingModeResource } from './';
import {
    ContractInvoicingModeResourceFromJSON,
    ContractInvoicingModeResourceFromJSONTyped,
    ContractInvoicingModeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContractTermsResource
 */
export interface ContractTermsResource {
    /**
     * 
     * @type {AppliedContractTermsResource}
     * @memberof ContractTermsResource
     */
    current: AppliedContractTermsResource;
    /**
     * 
     * @type {ContractInvoicingModeResource}
     * @memberof ContractTermsResource
     */
    pending?: ContractInvoicingModeResource;
}

/**
 * Check if a given object implements the ContractTermsResource interface.
 */
export function instanceOfContractTermsResource(value: object): value is ContractTermsResource {
    if (!('current' in value) || value['current'] === undefined) return false;
    return true;
}

export function ContractTermsResourceFromJSON(json: any): ContractTermsResource {
    return ContractTermsResourceFromJSONTyped(json, false);
}

export function ContractTermsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractTermsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'current': AppliedContractTermsResourceFromJSON(json['current']),
        'pending': json['pending'] == null ? undefined : ContractInvoicingModeResourceFromJSON(json['pending']),
    };
}

export function ContractTermsResourceToJSON(value?: ContractTermsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'current': AppliedContractTermsResourceToJSON(value['current']),
        'pending': ContractInvoicingModeResourceToJSON(value['pending']),
    };
}

